import Link from 'next/link'
import styles from '@/styles/home.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from '@/components/general/Image/Image'
import SwiperCore, { Autoplay } from 'swiper'

SwiperCore.use([Autoplay])
const BannerItem = ({
  image, imageMobile, link, priority
}, index) => (
  <SwiperSlide key={index}>
    <div className={styles.bannerItem} key={index}>
      <LinkWrapper href={link}>
        <>
        <Image src={image?.url} className="hide-xs" cover alt={image?.alternativeText} width="1920" height="700" layout="responsive" />
        {
          !!imageMobile?.url
            && <Image backgroundColor="linear-gradient(0deg, #0C2B3C 0%, #3E647A 100%)" src={imageMobile?.url} className="show-xs" alt={imageMobile?.alternativeText} width="414" height="543" layout="responsive" />
          }
        </>
      </LinkWrapper>
    </div>
  </SwiperSlide>
)

const LinkWrapper = ({ children, href }) => (
  href
    ? (
      <Link href={href}>
        <a href={href} target="_blank" rel="noreferrer">
          {children}
        </a>
      </Link>
    )
    : children
)

export const MainBanner = ({ data }) => (
  <Swiper className={styles.bannerWrap} autoplay={{ delay: 4000 }}>
    {data.map(BannerItem)}
  </Swiper>
)